// extracted by mini-css-extract-plugin
module.exports = {"panel":"PanelWrapper_panel__h6XgV","description":"PanelWrapper_description__QA01o"};